import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * ### **HeaderSearch**
 *
 * Buscador en forma de pildora que vive en la cabecera. Al enviarlo navega a `/search`
 * con el termino como query param, de modo que la busqueda real la sigue resolviendo
 * la pagina de busqueda y este componente no duplica esa logica.
 */
@Component({
  selector: 'app-header-search',
  imports: [ReactiveFormsModule, TranslatePipe],
  templateUrl: './header-search.component.html',
  styleUrl: './header-search.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderSearch {
  private readonly router = inject(Router);

  /** Texto guia del campo. */
  readonly placeholder = input('placeholder_search_label');

  /** Control del termino de busqueda. */
  protected readonly query = new FormControl<string>('', { nonNullable: true });

  /** Navega a la busqueda con el termino escrito. */
  protected submit(event: Event): void {
    event.preventDefault();

    const term = this.query.value.trim();
    if (!term) return;

    this.router.navigate(['/search'], { queryParams: { search_marker: term } });
  }
}
